module.exports = __webpack_public_path__ + "static/media/redecorating_map.04aecb7a.svg";